import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import { get, pageContext } from 'ctm-util-functions';

import { CloseButton } from '../close_button/close_button';

class _CallBack extends Component {

    /**
     * Dispatches TRACK_CALL_ME_BACK action when it is visible
     */
    componentDidUpdate = () => {
        const { dispatch, isVisible, stateProps } = this.props;
        if (isVisible) {
            scrollIntoView(this.node);
            dispatch({
                type: 'TRACK_CALL_ME_BACK',
                productId: get(stateProps, 'product.productMeta.id', null)
            });
        }
    };

    /**
     * Renders the children components through builderDirector
     * @returns {Node} constructed call me back html with layouts
     */
    render = () => {
        const { isVisible, layout, stateProps } = this.props;
        const quoteNumber = stateProps.product.getIn(['providerMeta', 'quoteNumber']);

        return (
            <div ref={(node) => { this.node = node; }}>
                { isVisible &&  <CloseButton stateProps={stateProps} id={'callBack'} /> }
                { isVisible && pageContext.getProps().director.constructComponents([layout], { resolvedStateProps: { quoteNumber }, stateProps }) }
            </div>
        );
    };

}

_CallBack.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    layout: PropTypes.string.isRequired,
    stateProps: PropTypes.object.isRequired,
    dispatch: PropTypes.func
};

const CallBack = connect()(_CallBack);
export { CallBack, _CallBack };
